import { createPlatformState, platformAction, platformGetters, platformMutations } from '~/helpers/store'

export default {
  state: () => createPlatformState(),
  actions: {
    async fetchFaqs ({ commit }) {
      await platformAction({
        client: this.$api.content.faqs,
        method: 'getAll',
        commit,
        logError: this.$logError,
        include: []
      })
    }
  },
  getters: {
    ...platformGetters,
    getFaqs: s => s.data || []
  },
  mutations: {
    ...platformMutations
  }
}
